/*
 * @Author: wyh
 * @Date: 2019-07-29 14:24:52
 * @Last Modified by: wyh
 * @Last Modified time: 2019-08-15 17:04:20
 * @Description: lookup 服务
 */

import { Injectable } from "@angular/core";
import { ModalController, Modal } from "ionic-angular";
import { GlobalState } from "../../common";

@Injectable()
export class ModelTemService {
  constructor(
    private modalCtrl: ModalController,
    private global: GlobalState,
  ) {}

  /**
   *
   * @param data 参数
   * @param page 目标页面 默认lookup页面
   * @param opts opts
   */
  lookupModal(data?, page = "ModelTemplateComponent", opts?): Modal {
    const defaultOpts = { cssClass: this.global.state.theme };
    opts = { ...defaultOpts, ...opts };
    return this.modalCtrl.create(page, data, opts);
  }
}



// WEBPACK FOOTER //
// ./src/services/business/model-tem/model-tem.service.ts